import contactService from '@/services/contact.service'
import { createGenericStore } from './generic.store'

export const useContactStore = createGenericStore<Contact>(
  'contacts',
  contactService,
)
